<template>
    <div class="ui-card">
        <div class="card-header">
            <div class="card-icon"><i class="nucfont" :class="icon"></i></div>
            <span class="card-title">{{title}}</span>
            <slot name="button"></slot>
        </div>
        <div class="card-body" :style="{'height': height}">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: String,
            icon: String,
            height: String
        },
        data() {
            return {

            }
        },
        created() {
        },
        computed: {

        },
        methods: {

        },
        components: {
        }
    }
</script>

<style lang="scss">
    @import '../../style/const';

    .ui-card {
        @include scrollbar();
        border: none;
        background-color: #fff;
        margin-bottom: 20px;
        box-shadow: 0 0 15px #e1e0d8;
        .card-header {
            display: flex;
            height: 40px;
            background-color: #f4f3f8;
            line-height: 40px;
            .card-title {
                flex:1;
                height: 40px;
                line-height: 40px;
                padding-left: 10px;
                color: #333;
                font-size: 16px;
                @include no-wrap
            }

            .card-icon {
                width: 45px;
                height: 40px;
                border-right: 1px solid #ccc;
                box-shadow: 1px 0 0 #fff;
                text-align: center;
                color: #2e7faa;
                line-height: 40px;
                //float: left;
                .nucfont {
                    font-size: 20px;
                    &.inuc-menu-assemble {
                        font-size: 18px;
                    }
                }
            }
        }

        .card-body {
            height: calc(100% - 40px);
            padding: 0 15px;
            color: #333;
            border-radius: 4px;
            overflow-x: hidden;
            overflow-y: auto;
        }
    }
</style>
